import { render, staticRenderFns } from "./ViewReportLimitation.vue?vue&type=template&id=4d46e5b3&"
import script from "./ViewReportLimitation.vue?vue&type=script&lang=js&"
export * from "./ViewReportLimitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports